<template>
  <vxe-modal ref="modal" size="mini" v-model="formVisible" title="明细处理" width="300px" @show="showModal">
    <el-form :model="form" ref="FormRef" :validate-on-rule-change="false" :rules="rules" size="mini">
      <el-form-item label="处理结果" prop="handleResult">
        <el-select clearable v-model="form.handleResult" :placeholder="placeholderConfig.select">
          <el-option label="接收" value="接收"></el-option>
          <el-option label="不处理" value="不处理"></el-option>
        </el-select>
        <template slot="error" slot-scope="slot">
          <errorTooltip :content="slot.error"></errorTooltip>
        </template>
      </el-form-item>
      <el-form-item
        label="要求完成日期"
        v-show="form.handleResult === '接收' && modalSource === 'DataProcessing'"
        prop="deadLineTime"
      >
        <el-date-picker
          v-model="form.deadLineTime"
          v-date
          type="date"
          value-format="yyyy-MM-dd"
          :placeholder="placeholderConfig.input"
        ></el-date-picker>
        <template slot="error" slot-scope="slot">
          <errorTooltip :content="slot.error"></errorTooltip>
        </template>
      </el-form-item>
      <el-form-item label="处理说明" prop="handleNote">
        <el-input type="textarea" v-model="form.handleNote" :placeholder="placeholderConfig.input"></el-input>
        <template slot="error" slot-scope="slot">
          <errorTooltip :content="slot.error"></errorTooltip>
        </template>
      </el-form-item>
    </el-form>
    <el-button @click="handleCommit" style="float: right; margin-top: 10px" size="mini" type="primary">确认</el-button>
  </vxe-modal>
</template>
<script>
export default {
  name: 'AcceptModal',
  props: {
    modalSource: {
      type: String,
      default: 'Question'
    }
  },
  data() {
    return {
      formVisible: false,
      form: {
        handleResult: '',
        handleNote: '',
        deadLineTime: ''
      },
      rules: {
        handleResult: [{ required: true, message: '请选择处理结果', trigger: 'change' }],
        handleNote: [
          { validator: this.validNote, trigger: 'change' },
          {
            min: 0,
            max: 64,
            message: '长度在 0 到 64 个字符',
            trigger: 'change'
          }
        ]
      },
      // 是否限制当天之后时间不能选择
      isLimitToday: true,
      // 日期选择框配置项
      pickerOptions: null
    }
  },
  methods: {
    // 校验处理说明
    validNote(rule, value, callback) {
      if (this.form.handleResult === '不处理' && !value) {
        callback(new Error('当处理结果为不处理时处理说明为必填!'))
      } else {
        callback()
      }
    },
    showModal() {
      this.form = {
        deadLineTime: '',
        handleResult: '',
        handleNote: ''
      }
      this.$nextTick(() => {
        this.$refs.FormRef.clearValidate()
      })
    },
    async handleCommit() {
      const valid = await this.validEnter()
      if (!valid) {
        this.$message.error('校验失败,请检查内容是否合法')
        return
      }
      this.$emit('sureHandler', this.form)
      this.$nextTick(() => {
        this.formVisible = false
      })
    },
    async validEnter() {
      let flag = false
      await this.$refs.FormRef.validate().then(
        res => {
          flag = res
        },
        err => {
          flag = err
        }
      )
      return flag
    }
  }
}
</script>
<style lang="less" scoped>
// vxemodal部分，美化标题太大的问题
/deep/ .vxe-modal--header {
  // font-size: 12px !important;
  height: 26px !important;
  padding: 2px 10px 0 10px !important;
}

// vxemodal关闭按钮
/deep/ .vxe-modal--close-btn {
  position: absolute !important;
  right: 8px !important;
  top: 6px !important;
  z-index: 1 !important;
  cursor: pointer !important;
}

// vxemodal标题
/deep/ .vxe-modal--title {
  font-size: 12px !important;
}
</style>
